import { z } from 'zod'

import * as api from '../api'
import useApiMutation from './useApiMutation'

const createUserResponseParser = z.object({
  uuid: z.string(),
  url: z.string().nullish(),
  initialPassword: z.string().nullish(),
})

export interface CreateUserArguments {
  firstname: string
  lastname: string
  position?: string | null
  username?: string
  email?: string
  role: string
  isActive: boolean
}

export default function useCreateUser() {
  return useApiMutation({
    mutationFn: async (data: CreateUserArguments) =>
      createUserResponseParser.parse(
        await api.post('user', {
          firstname: data.firstname,
          lastname: data.lastname,
          position: data.position !== undefined ? data.position || null : undefined,
          username: data.username || null,
          email: data.email || null,
          role: data.role,
          status: data.isActive ? 'active' : 'inactive',
        })
      ),
  })
}
